import { beforeDate, afterDate } from '../Hooks/useDateFns';

export const SortByDateAscending = (a: string, b: string): number => {
  if (beforeDate(a, b)) {
    return -1;
  }
  if (afterDate(a, b)) {
    return 1;
  }
  return 0;
};

export const SortByDateDescending = (a: string, b: string): number => {
  if (beforeDate(a, b)) {
    return 1;
  }
  if (afterDate(a, b)) {
    return -1;
  }
  return 0;
};

export const SortByNameAscending = (a: string, b: string): number => {
  if (a > b) {
    return 1;
  }
  if (a < b) {
    return -1;
  }
  return 0;
};

export const SortByNameDescending = (a: string, b: string): number =>
  -1 * SortByNameAscending(a, b);

export const SortByNameCaseInsensitiveAscending = (a: string, b: string): number => {
  if (a.toLocaleLowerCase() > b.toLocaleLowerCase()) {
    return 1;
  }
  if (a.toLocaleLowerCase() < b.toLocaleLowerCase()) {
    return -1;
  }
  return 0;
};

export const SortByNameCaseInsensitiveDescending = (a: string, b: string): number => {
  if (a.toLocaleLowerCase() > b.toLocaleLowerCase()) {
    return -1;
  }
  if (a.toLocaleLowerCase() < b.toLocaleLowerCase()) {
    return 1;
  }
  return 0;
};

export const SortByKey = <T>(array: T[], key: keyof T, order = 1): T[] =>
  [...array].sort((a: T, b: T) => {
    if (a[key] < b[key]) {
      return -1 * order;
    }
    if (a[key] > b[key]) {
      return 1 * order;
    }
    return 0;
  });

export const getSortOptionForType = (type: string) => {
  const sort = SortingOptions.find((option) => option.type === type);
  if (!sort) {
    return SortingOptions[0];
  }
  return sort;
};

export const SortingOptions = [
  { type: 'dateasc', label: 'app.sort.dateasc', func: SortByDateAscending },
  { type: 'datedesc', label: 'app.sort.datedesc', func: SortByDateDescending },
  { type: 'nameasc', label: 'app.sort.nameasc', func: SortByNameAscending },
  { type: 'namedesc', label: 'app.sort.namedesc', func: SortByNameDescending },
];

export const CustomerSortOptions = [
  { type: 'nameasc', label: 'app.sort.nameasc', func: SortByNameAscending },
  { type: 'namedesc', label: 'app.sort.namedesc', func: SortByNameDescending },
];

export type SortOptions = typeof SortingOptions;
